import React from 'react';
import AppLayout from '../../components/AppLayout';
import OverviewList from '../../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,
        Segment,LoadGraphic,Step,DynamicListArea,BulkEdit, Dropzone} from '../../components/Common';
import {Input,Button,Area,Select,TextButton} from '../../components/Input';
import u from '../../utilities/Utilities';
import moment from 'moment';
import {Attachment} from '../../data/Mimetypes';

export default class StoreItemList extends React.Component{

    r={};

    settings={
        /**** Page Setup ****/
        title:"Store Item",
        permission:"inventory",  //Accepts combined permission module as well
        //combinedField:"price",     //Used when permission exists in a combined field
        url:"/store-item-list",

        /**** Action Setup ****/
        addType:1,
        addURL:"/api/add-store-item-entry",
        //templateURL:"/api/get-add-tenant-template",
        //bulkURL:"/api/add-bulk-tenants",
        deleteURL:"/api/delete-store-item-entries",
        spreadsheetURL:"/api/generate-store-item-spreadsheet",
        overviewURL:"/api/get-all-store-item-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"store-item-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddItem,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        options:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (bulkEditOptions.length > 0 && (permissions.update));
        this.setState({
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.create)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ],
            permissions:permissions,
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                              index={index}
                                              content={content}
                                              onChange={onChange}
                                              onContentChange={onContentChange}
                                              registerReference={registerRef}
                                              options={this.state.options}
                                              settings={this.settings}
                                              permissions={this.state.permissions}
                                              />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{
    r={};

    state={
        step:"view",
        error:"",
        loading:false,
        loadText:"",
        filetypeOptions:[
            {value:"operatingManual",label:"Operating Manual"},
            {value:"licenseFile",label:"License File"},
        ]
    };

    onDrawn=()=>{
        const {content}=this.props;
        window.open("/inventory-item-list?tags=@itemCode("+content.itemCode+")","_blank");
    }

    onActivity=()=>{
        const {content}=this.props;
        window.open("/store-activity?tags=@itemCode("+content.itemCode+")","_blank")
    }

    onUploadFile=()=>{
        this.onFileChosen=()=>{
            const fileType = this.r['fileType'].validate();
            if(!fileType.valid){
                this.setState({error:fileType.value});
                return 0;
            }
            this.fileType=fileType.value;
            this.setState({step:"upload",error:"",fileType:fileType.option.label});
        }

        this.onFileUpload=async (url,filename)=>{
            try{
                const response=await u.postAsync({
                    url:"/api/store-item-upload-file",
                    data:{
                        field:this.fileType,
                        filename:url,
                        userFilename:filename,
                    }
                });

                this.props.onChange(1,"has"+this.fileType,this.props.index);
                this.props.onChange(response.data,this.fileType,this.props.index);
                this.setState({step:"view",loading:false,error:""});
            }
            catch(e){
                const {error,status}=u.processError(e);
                this.setState({error:error,loading:false});
            }
        }

        this.setState({step:"choose-file",error:""});
    }

    onDownloadFile=()=>{
        this.onFileChosen=()=>{
            const fileType = this.r['fileType'].validate();
            if(!fileType.valid){
                this.setState({error:fileType.value});
                return 0;
            }
            this.fileType=fileType.value;
            const {content}=this.props;
            this.setState({loading:true,loadText:"Downloading..."});
            if(content[this.fileType]?.filestamp){
                u.download(
                    content[this.fileType].filename,
                    content[this.fileType].filestamp,
                    ()=>{
                        this.setState({step:"view",loading:false})
                    },
                    (error)=>{
                        this.setState({error:error,loading:false});
                    }
                )
            }
            else{
                this.setState({error:"File is not found, please upload before attempting to download",loading:false});
            }
        }

        this.setState({step:"choose-file",error:""});
    }

    render=()=>{
        const {content,options,settings,onChange,permissions} = this.props;
        const {filetypeOptions}=this.state;
        const canEdit = (permissions.create==2);

        return (
            <div>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>

                <Step active={this.state.step == "view"}>
                    <div className="list-segment-error">{this.state.error}</div>
                    <DynamicListArea content={content}
                                     onChange={onChange}
                                     index={this.props.index}
                                     listLabel={settings.listLabel}
                                     permission={settings.permission}
                                     bypassPermission={canEdit}
                                     />

                    {
                        (content.itemType != "Consumable")
                            ?
                            <div style={{margin:"20px auto",textAlign:"center"}}>
                                <Button onClick={this.onUploadFile}>Upload File</Button>
                                <Button onClick={this.onDownloadFile}>Download File</Button>
                            </div>
                            :
                            null
                    }

                    <div style={{margin:"20px auto",textAlign:"center"}}>
                        <TextButton onClick={this.onDrawn}>See Drawn List</TextButton>
                        <TextButton onClick={this.onActivity}>See Activity List</TextButton>
                    </div>
                </Step>

                <Step active={this.state.step=="choose-file"}>
                    <div style={{position:"relative",padding:"30px 0",textAlign:"center"}}>
                        <h2>Select File Type</h2>
                        <div className='segment-full-item' style={{fontSize:"14px"}}>
                            <div className='segment-item-input'>
                                <Select ref={(ref)=>{this.r['fileType']=ref}}
                                        values={{options:filetypeOptions}}
                                        label="File Type"
                                        />
                            </div>
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={()=>{this.onFileChosen()}}>Next</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="upload"}>
                    <div style={{position:"relative",padding:"10px 0",textAlign:"center"}}>
                        <h2 style={{margin:"0"}}>Uploading {this.state.fileType}</h2>
                        <Dropzone label="FileDropzone"
                                accessibleForPreview={false}
                                onAdded={(filename)=>{this.filename=filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                onUploaded={(url)=>{this.onFileUpload(this.filename,url)}}
                                onError={(error)=>{this.setState({error:error,loading:false})}}
                                onProgress={(percent)=>{this.setState({loadText:"Uploading..." + percent + "%"})}}
                                filetypes={Attachment}
                                />

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }

}

class AddItem extends React.Component{

    r={};

    settings={
        addType:0,
        addURL:"/api/add-store-item-entry",
    }

    state={
        step:"view",
        entryData:{
            itemType:"Personal Equipment",
            drawLogic:"One to One",
        },
        options:{},
        assetOptions:[],
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    componentDidMount=()=>{
        this.getOptions();
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{keys:[
                    "inventoryItemType","inventoryDrawLogic"
                ]}
            });

            const r2=await u.postAsync({
                url:"/api/get-active-store-items",
                data:{
                    itemType:"Asset"
                }
            });

            this.setState({
                options:response.data,
                assetOptions:r2.data.map((item)=>{
                    return {value:item.itemID,label:item.itemCode + " - " +item.itemName}
                })
            });
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        this.r[this.props.reference].onValidated(data);
    }

    onComplete=()=>{
        this.setState({
            entryData:{
                itemType:"Personal Equipment",
                drawLogic:"One to One",
            },
            step:"view"
        });
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    drawLogicInstruction="<b>One to One</b><br/>User can only draw up to issuance limit, any other draw down will require user to return a drawn item as a replacement.<br/><br/>" +
                         "<b>Fire and Forget</b><br/>Item can be drawn without limits. Transactions are stored in store activity, but will not be displayed in Inventories.<br/><br/>" +
                         "<b>Replacement Task</b><br/>An active replacement task with the respective item must be assigned to the user to draw this item.<br/><br/>" + 
                         "<b>Provide Return Date/Reason</b><br/>User needs to provide a reason and return date upon drawing this item.<br/><br/>"

    render=()=>{
        const {loading,loadText,step,options,assetOptions,entryData}=this.state;
        
        const itemType={
            "Personal Equipment":[],
            "Consumable":[
                {dataType:"box",label:"Purchase/Serving Ratio",field:"purchaseToServingRatio",type:"number",rules:{required:true,minValue:1,defaultValue:1},info:"How many servings can be distributed from each quantity purchased? E.G. 1 Barrel can have 30 serving Bottles"},
                {dataType:"box",label:"Serving Quantifier",field:"servingQuantifier",rules:{required:true,defaultValue:"Piece(s)"},info:"How do you quantify 1 serving of this item? E.G. Piece(s), Bottle(s), Packet(s)"},
                {dataType:"box",label:"Initial Serving Quantity",field:"initialServingQuantifier",type:"number",rules:{required:true,minValue:0,defaultValue:"0"},info:"Number of remaining undistributed servings of this item?"},
            ],
            "Asset":[],
            "Asset Part":[
                {dataType:"select",label:"Parent Asset",field:"parentAssetID",options:assetOptions,rules:{required:true},info:"Which is the parent asset that this item is part of?<br/><br/>Create the parent asset before creating the parts"},
            ],
            "Others":[],
        };

        const drawLogic={
            "One to One":[
                {dataType:"box",label:"Issuance Limit",field:"issuanceLimit",type:"number",rules:{required:true,minValue:1},info:"What is the maximum limit to drawn items, if limit is reached, the user cannot draw an item unless he returns one that is currently drawn"},
            ],
            "Fire and Forget":[],
            "Replacement Task":[],
            "Provide Reason/Return Date":[],
        };

        const fields=[
            {dataType:"box",label:"Item Name",field:"itemName",rules:{required:true}},
            {dataType:"box",label:"Item Code",field:"itemCode",rules:{required:true}},
            {dataType:"select",label:"Item Type",field:"itemType",options:options.inventoryItemType,rules:{required:true,minValue:1}},
            {dataType:"select",label:"Draw Logic",field:"drawLogic",options:options.inventoryDrawLogic,rules:{required:true},info:this.drawLogicInstruction},
            {dataType:"box",label:"Purchase Quantifier",field:"purchaseQuantifier",rules:{required:true,defaultValue:"Piece(s)"},info:"How do you quantify 1 portion of this item when it is purchased? E.G. Piece(s), 12P Carton(s), 20L Barrel(s)"},
            {dataType:"box",label:"Initial Quantity",field:"initialQuantity",type:"number",rules:{required:true,defaultValue:0,minValue:0},info:"How many of these items do you currently already have in total?"},
        ].concat(itemType[entryData.itemType]).concat(drawLogic[entryData.drawLogic]);

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={true}
                         onToggleForm={this.props.onToggleForm}
                         >
                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="view"}>
                        <h3>Complete the following fields to continue</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>
                </div>
            </AddListItem>
        )
    }
}